import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { CustomTagComponent } from './custom-tag.component';

@NgModule({
	declarations: [CustomTagComponent],
	imports: [CommonModule, TranslateModule.forChild(), FreudTypographyModule],
	exports: [CustomTagComponent],
})
export class CustomTagModule {}
